export const ProductPodDomains = [
  'identifiers',
  'info',
  'media',
  'details',
  'badges',
  'reviews',
  'availabilityType',
  'pricing',
  'fulfillment',
  'favoriteDetail',
  'sizeAndFitDetail'
];
